import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { resendSettingsService } from '../api/resend-settings.service';

export function useResendSettings() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: queryKeys.resendSettings, queryFn: resendSettingsService.get });
  const save = useMutation({ mutationFn: (patch: Parameters<typeof resendSettingsService.update>[0]) => resendSettingsService.update(patch),
    onSuccess: (data) => client.setQueryData(queryKeys.resendSettings, data) });
  return { query, save };
}
